import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  RecurringDocument, RecurringDocumentDetail, RecurringDocumentKind, RecurringDocumentPrefill, RecurringDocumentRequest,
  RecurringDocumentRun, RecurringDocumentRunResult, RecurringDocumentStatus,
} from '../interfaces/recurringDocument.interface';

const E = ENDPOINTS.RECURRING_DOCUMENT;

export const RecurringDocumentService = {
  list: async (institutionId: string, kind?: RecurringDocumentKind, status?: RecurringDocumentStatus, partyId?: string): Promise<RecurringDocument[]> =>
    (await axios.get(E.LIST(institutionId), { params: { kind, status, partyId } })).data,
  get: async (id: string): Promise<RecurringDocumentDetail> => (await axios.get(E.BY_ID(id))).data,
  prefill: async (institutionId: string, kind: RecurringDocumentKind, documentId: string): Promise<RecurringDocumentPrefill> =>
    (await axios.get(E.PREFILL(institutionId, kind, documentId))).data,
  create: async (req: RecurringDocumentRequest): Promise<RecurringDocument> => (await axios.post(E.BASE, req)).data,
  update: async (id: string, req: RecurringDocumentRequest): Promise<RecurringDocument> => (await axios.put(E.BY_ID(id), req)).data,
  pause: async (id: string): Promise<RecurringDocument> => (await axios.post(E.PAUSE(id))).data,
  resume: async (id: string): Promise<RecurringDocument> => (await axios.post(E.RESUME(id))).data,
  end: async (id: string): Promise<RecurringDocument> => (await axios.post(E.END(id))).data,
  remove: async (id: string): Promise<void> => { await axios.delete(E.BY_ID(id)); },
  runNow: async (id: string): Promise<RecurringDocumentRunResult> => (await axios.post(E.RUN_NOW(id))).data,
  retryRun: async (runId: string): Promise<RecurringDocumentRun> => (await axios.post(E.RETRY_RUN(runId))).data,
  skipRun: async (runId: string): Promise<RecurringDocumentRun> => (await axios.post(E.SKIP_RUN(runId))).data,
  linkRun: async (runId: string, documentId: string): Promise<RecurringDocumentRun> =>
    (await axios.post(E.LINK_RUN(runId), { documentId })).data,
};
